import React, { createContext, useContext, useMemo } from 'react';
import { apiClient as baseApiClient, authFetch as baseAuthFetch } from '../services/apiClient';

export const PAINT_UNIT = 'pinturas';
export const ADDITIVES_UNIT = 'aditivos';

// Routers whose data is split by business area (backend `business_unit` query param).
const SCOPED_API_PATH = /\/api\/(organizations|contacts|rubrics|quotations)(\/|$|\?)/;

export function withBusinessUnit(url, unit) {
  const value = String(url || '');
  if (!unit || unit === PAINT_UNIT || !SCOPED_API_PATH.test(value) || /[?&]business_unit=/.test(value)) {
    return value;
  }
  return `${value}${value.includes('?') ? '&' : '?'}business_unit=${encodeURIComponent(unit)}`;
}

const BusinessUnitContext = createContext(PAINT_UNIT);

export function BusinessUnitProvider({ unit = PAINT_UNIT, children }) {
  return <BusinessUnitContext.Provider value={unit}>{children}</BusinessUnitContext.Provider>;
}

export function useBusinessUnit() {
  return useContext(BusinessUnitContext);
}

/**
 * `authFetch` / `apiClient` que acotan al área actual las llamadas a los routers comerciales.
 * Los módulos comerciales compartidos entre Pinturas y Aditivos deben usar estos en vez de
 * importarlos de `services/apiClient`, para que Aditivos no vea datos de Pinturas.
 */
export function useBusinessUnitApi() {
  const unit = useBusinessUnit();
  return useMemo(
    () => ({
      unit,
      authFetch: (url, options) => baseAuthFetch(withBusinessUnit(url, unit), options),
      apiClient: (url, options) => baseApiClient(withBusinessUnit(url, unit), options),
    }),
    [unit]
  );
}
